<template>
  <div>
    <ida-topbar
      :brand="$t('head.title')"
      @brandClick="handleLinkClick('templates')"
      :tabs="tabs"
      @tabClick="handleLinkClick"
      :CTA="$t('CTA.new')"
      @CTAClick="handleLinkClick('newTemplate')"
      product="PLAYERLIST"
      :accountOptions="accountOptions"
      @accountOptionClick="handleAccountOptionClick"
      :locale="currentLanguage"
      :languages="languages"
      :current-language="currentLanguage"
      @languageClick="handleLanguageClick" />
    <transition name="fade" mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>
import i18n from '@/lang/index'
import moment from 'moment'
import Cookies from 'js-cookie'
export default {
  name: 'iDalgo-Default',
  computed: {
    tabs () {
      return [
        {
          text: this.$t('iDalgoDefault.archives'),
          link: 'templates',
          current: this.$route.name === 'templates'
        }
      ]
    },
    currentLanguage () {
      return i18n.locale
    },
    languages () {
      return Object.keys(i18n.messages)
    },
    accountOptions () {
      return {
        logout: this.$t('iDalgoDefault.logout')
      }
    }
  },
  methods: {
    handleLinkClick (link) {
      if (link === 'templates' && this.$route.name === 'templates') {
        const surveysView = this.$children.find(child => child.$el.classList.contains('iDalgo-Template'))
        surveysView.searchString
          ? surveysView.searchString = ''
          : surveysView.handleSearchString()
      }
      this.$router.push({ name: link })
    },
    handleLanguageClick (locale) {
      i18n.locale = locale.toLowerCase()
      moment.locale(locale)
      Cookies.set('locale', locale, { expires: 20000, domain: process.env.DOMAIN })
    },
    handleAccountOptionClick (key) {
      switch (key) {
        case 'logout':
          this.$store.dispatch('auth/logout')
          break
        default:
          break
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
body, html {
  font-family: "robotoregular","Helvetica Neue",Helvetica,Arial,sans-serif;
  background: $light-gray;
}

.el-row > * {
  display: flex;
  padding: $default_padding;
}

.el-main {
  max-width: 1200px;
  width: 100%;
  margin: auto;
  min-height: calc(100vh - 120px);
}

.button-icon {
  font-family: 'robotolight';
  display: flex;
  flex-flow: column;
  align-items: center;
  color: $logo-gray;
  font-size: 16px;

  span {
    padding-top: $default_padding / 4;
    font-size: 10px;
    color: $text-gray;
  }
}

.text-empty {
  background: darken($light-gray, 10%);
  background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);
  background-size: 800px 104px;
  animation: placeHolderShimmer 3s forwards infinite ease-in-out;
}

pre {
  word-wrap: break-word;
  white-space: pre-wrap;
  padding: 20px 20px;
  color: $color1;
  font-family: 'robotoregular';
  font-size: 14px;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.2s ease-out;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

@keyframes placeHolderShimmer{
  0%{
      background-position: -468px 0
  }
  100%{
      background-position: 468px 0
  }
}

</style>



// WEBPACK FOOTER //
// src/layouts/iDalgo-Default.vue